module.exports = __webpack_public_path__ + "img/gc.97340de0.svg";